import { ActionTree } from "vuex";
import { INotificationState, INotificationItem } from "./interface";
import { IStoreRootState } from "@/store/interface";

export let toastId: number = 0;

export default <ActionTree<INotificationState, IStoreRootState>> {

	async addToast({ commit }, toast: INotificationItem): Promise<number> {
		const id: number = ++toastId;

		commit('addToast', Object.assign(toast, { id }));

		return id;
	}

}